import { BasicType } from "@easy-email-pro-core/constants";
import { TableElement } from "@easy-email-pro-core/typings";
import { BlockRenderer } from "../BlockRenderer";
import React from "react";
import { RecursivePartial } from "@easy-email-pro-core/typings/helper";
import { isString } from "lodash";

export type TableProps = RecursivePartial<
  Omit<TableElement["attributes"], "children">
> & {
  idx?: string | null;
  children: string | React.ReactNode;
  data?: TableElement["data"];
};

export function Table(props: TableProps) {
  const { idx, children, ...rest } = props;

  const node: TableElement = {
    type: BasicType.TABLE,
    data: { code: isString(children) ? String(children) : "" },
    attributes: { ...rest },
    children: [],
  };

  return (
    <BlockRenderer
      idx={idx}
      node={node}
      children={isString(children) ? null : children}
    />
  );
}
